import { createTopNavLucideIcon } from "@dashboard/icons/createNavigationLucideIcon";
import { Warehouse } from "lucide-react";

/** The inventory pages' TopNav destination: back to the stock lookup. */
export const AtticInventoryDestinationIcon = createTopNavLucideIcon(Warehouse);
